import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { ISproutCardLinkProps } from "./SproutCardLink.props";

export const SproutCardLink = ({ children, className, link }: ISproutCardLinkProps) => {
  const classes = cn(
    "group block rounded-[1.35rem_1.35rem_1.35rem_0.3rem] border-2 border-navy-ink/15 bg-whiteboard transition-[background-color,border-color,transform,box-shadow] duration-200 ease-out",
    link &&
      "hover:-translate-y-1 hover:rotate-[0.35deg] hover:border-navy-ink hover:shadow-[0_7px_0_#45b8e8,0_18px_30px_-24px_rgba(20,33,61,0.55)] focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-ring",
    className,
  );

  if (!link) return <article className={classes}>{children}</article>;

  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};

SproutCardLink.displayName = "Content::SproutCardLink";
